import { useMemo, useCallback } from "react";
import Image from "next/image";
import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  Link,
  Box,
  Flex,
  useColorMode,
  Text,
  Center,
  useColorModeValue,
} from "@chakra-ui/react";

import { AiOutlineMore } from "react-icons/ai";

import chevron_right_light from "../assets/chevron_right_light.svg";
import chevron_right_dark from "../assets/chevron_right_dark.svg";
import faq_dark from "../assets/faq_dark.svg";
import faq_light from "../assets/faq_light.svg";
import support_light from "../assets/support_light.svg";
import support_dark from "../assets/support_dark.svg";
import theme_dark from "../assets/theme_dark.svg";
import theme_light from "../assets/theme_light.svg";

import ThemeSwitcher from "../ThemeSwitcher";
import { IIndexable } from "../constants";

interface HeaderProps {
  headerOptins: any;
  //   onSubHeaderMenuClick(key: string): void;
}

const SUBHEADER_ICONS: IIndexable = {
  light: {
    support: support_light,
    faq: faq_light,
    theme: theme_light,
  },
  dark: {
    support: support_dark,
    faq: faq_dark,
    theme: theme_dark,
  },
};

const SubHeader = ({
  headerOptins,
}: //   onSubHeaderMenuClick,
HeaderProps) => {
  const { colorMode } = useColorMode();

  const ChrevonRight = useColorModeValue(
    chevron_right_light,
    chevron_right_dark
  );

  const getHeaderItem = (item: any) => {
    return (
      <Flex justifyContent="space-between" alignItems="center" mt="1.5rem">
        <Flex alignItems="center">
          <Center
            h={{ base: "32px", md: "40px" }}
            w={{ base: "32px", md: "40px" }}
            borderRadius="50%"
            bg="#F5F5F7"
            _dark={{
              bg: "#202022",
            }}
          >
            {item.key && (
              <Image
                width="24px"
                height="24px"
                src={SUBHEADER_ICONS[colorMode][item.key]}
                alt={item.key}
              />
            )}
          </Center>

          <Text fontWeight="600" fontSize="16px" lineHeight="24px" ml="1rem">
            {item.title}
          </Text>
        </Flex>

        {item.key === "theme" ? (
          <Box>
            <ThemeSwitcher />
          </Box>
        ) : (
          <Image
            src={ChrevonRight}
            width="24px"
            height="24px"
            alt="link-icon"
          />
        )}
      </Flex>
    );
  };

  const getSubHeader = () =>
    headerOptins.map(
      (item: { link: string | undefined; onClick?: () => void }) =>
        item?.link ? (
          <Link
            cursor="pointer"
            href={item.link}
            target="_blank"
            rel="nofollow"
            onClick={() => item?.onClick && item.onClick()}
          >
            {getHeaderItem(item)}
          </Link>
        ) : (
          <Box>{getHeaderItem(item)}</Box>
        )
    );

  return (
    <>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={
            <AiOutlineMore
              height="24px"
              width="24px"
              color={colorMode === "light" ? "#000000" : "#FFFFFF"}
            />
          }
          variant="icon"
          //   ml={{ base: "4px", lg: "1rem" }}
          bg="brand.backgroundLight"
          display={{ base: "none", sm: "inline-flex" }}
          borderRadius="0.5rem"
          h="48px"
          w="48px"
          mr={{ base: "16px", md: "0px" }}
        />
        <MenuList
          borderRadius="1rem"
          bg="brand.backgroundLight"
          p="0rem 1.5rem 2rem"
          display="flex"
          flexDirection="column"
          boxShadow="4px 24px 40px rgba(0, 0, 0, 0.12)"
          width="280px"
          maxW="98%"
          zIndex="4"
        >
          {getSubHeader()}
        </MenuList>
      </Menu>
    </>
  );
};

export default SubHeader;
